export default "__VITE_PUBLIC_ASSET__73e6d4c4__"